import * as Yup from 'yup';
import { checkBoxRequried, emailOptional, nameOptional, nameRequired, phoneNumberRequired } from '.';

export const contactSchema = Yup.object({
    contact_name: nameRequired,
    contact_email: emailOptional,
    contact_position: nameOptional,
    contact_number: phoneNumberRequired,
    is_primary: checkBoxRequried
});
